import * as React from 'react';
import type { RouteObject } from 'react-router-dom';
import { Outlet } from 'react-router-dom';

export const route: RouteObject = {
  path: '/',
  element: <Outlet />,
  children: [
    {
      path: 'reset-password',
      lazy: async () => {
        const { Page } = await import('@/pages/v2/auth/reset-password');
        return { Component: Page };
      },
    },
    {
      path: 'reset-password/confirm',
      lazy: async () => {
        const { Page } = await import('@/pages/v2/auth/reset-password-confirm');
        return { Component: Page };
      },
    },
    {
      path: 'sign-in',
      lazy: async () => {
        const { Page } = await import('@/pages/v2/auth/sign-in');
        return { Component: Page };
      },
    },
    {
      path: 'change-password',
      lazy: async () => {
        const { Page } = await import('@/pages/v2/auth/change-password');
        return { Component: Page };
      },
    },
  ],
};
